// eslint-disable-next-line import/prefer-default-export
export const COHORT_DIALOG_ACTIONS = {
  SAVE: 'save',
  DELETE: 'delete',
};
